import React from 'react';
import ClientUrl from './ClientUrl.jsx'
import TablePagination from 'components/Pagination/TablePagination';
import Headers from './Headers.jsx';

export const ClientUrlsList = ({
  clientUrls,
  checkedClientUrlIds,
  client_urls_ids,
  paginationProps,
  onOrderChange,
  query
})  => (
  <table>
    <Headers
      onChange={onOrderChange}
      value={query.order}
    />
    { clientUrls.map(clientUrl => (
      <ClientUrl
        clientUrl={clientUrl}
        checkedClientUrlIds={checkedClientUrlIds}
        key={clientUrl.id}
        client_urls_ids={client_urls_ids}
      />
    ))}
    <tr>
      <td colSpan="9">
        <TablePagination
          {...paginationProps}
        />
      </td>
    </tr>
  </table>
);



// WEBPACK FOOTER //
// ./src/components/Admin/ClientUrls/List/ClientUrlsList.jsx